(function () {
    const TRACKING_THRESHOLDS = [25, 50, 75, 90];
    const THROTTLE_MS = 100;
    const triggeredThresholds = new Set();

    let cachedDocHeight = 0;
    let cachedWinHeight = 0;
    let scrollEndTimer = null;
    let tick = false;
    let lastRunTime = 0;

    let bottomCheckTimer = null;
    let pendingBottomReport = false;

    const updateCache = () => {
        cachedDocHeight = document.documentElement.scrollHeight;
        cachedWinHeight = window.innerHeight;

        if (pendingBottomReport) {
            if (bottomCheckTimer) clearTimeout(bottomCheckTimer);
            bottomCheckTimer = null;
            pendingBottomReport = false;
        }
    };

    const reportEvent = (threshold) => {
        if (triggeredThresholds.has(threshold)) return;

        triggeredThresholds.add(threshold);

        const eventName = 'page_scroll_depth';
        const eventData = { depth: threshold, page_path: window.location.pathname, page_title: document.title };

        if (window.DLPixelH && typeof window.DLPixelH.capture === 'function') {
            try {
              window.DLPixelH.capture(eventName, eventData);
            }
            catch (error) {
              console.warn(error);
            }
        }
    };

    const checkDepth = (useCache = true) => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let currentDocHeight = useCache ? cachedDocHeight : document.documentElement.scrollHeight;
        let currentWinHeight = useCache ? cachedWinHeight : window.innerHeight;

        if (currentDocHeight <= 0) return;
        let rawPercent = ((scrollTop + currentWinHeight) / currentDocHeight) * 100;

        if (useCache && rawPercent >= 99) {
            const freshDocHeight = document.documentElement.scrollHeight;
            if (freshDocHeight !== currentDocHeight) {
                currentDocHeight = freshDocHeight;
                cachedDocHeight = freshDocHeight;
                rawPercent = ((scrollTop + currentWinHeight) / currentDocHeight) * 100;
            }
        }

        const scrollPercent = Math.min(rawPercent, 100);

        TRACKING_THRESHOLDS.forEach(threshold => {
            if (scrollPercent >= threshold) {
                reportEvent(threshold);
            }
        });

        if (scrollPercent >= 99 && !triggeredThresholds.has(100)) {
            if (!pendingBottomReport) {
                pendingBottomReport = true;
                bottomCheckTimer = setTimeout(() => {
                    if (pendingBottomReport) {
                        reportEvent(100);
                        pendingBottomReport = false;
                        bottomCheckTimer = null;
                    }
                }, 800);
            }
        }
    };

    const init = () => {
        updateCache();

        if (window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(updateCache);
            });
            if (document.body) resizeObserver.observe(document.body);
        }

        window.addEventListener('scroll', () => {
            if (!tick) {
                window.requestAnimationFrame(() => {
                    const now = Date.now();
                    if (now - lastRunTime >= THROTTLE_MS) {
                        checkDepth(true);
                        lastRunTime = now;
                    }
                    tick = false;
                });
                tick = true;
            }

            if (scrollEndTimer) clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(() => {
                checkDepth(false);
            }, 200);
        }, { passive: true });

        const flushPending = () => {
            if (pendingBottomReport) {
                reportEvent(100);
            }
        };
        
        window.addEventListener('pagehide', flushPending);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                flushPending();
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    }
    else {
        init();
    }

})();